import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./BusinessSlotReservation.css";

const BusinessPublicProfile = ({quest}) => {
  const { businessId } = useParams();
  const [publicData, setPublicData] = useState(null);
  const [message, setMessage] = useState(null);
  const { user, userToken, business, businessToken, fetchBusiness } = useAuth();
  const [sending, setSending] = useState(false)
  const [reservationData, setReservationData] = useState({
    user,
    business: businessId,
    service: '',
    date: '',
    timeSlots: [],
    duration: 0,
  }); 

  const [businessReservationData, setBusinessReservationData] = useState({
    business: businessId,
    date: '',
    timeSlots: [],
    duration: "",
  });

  const [selectedDate, setSelectedDate] = useState(new Date())
  const [formatedSelectedDate, setFormatedSelectedDate] = useState(null);
  const [slots, setSlots] = useState([]);
  const [reservationDataWithName, setReservationDataWithName] = useState({
    name: "",
    business: businessId,
    service: '',
    date: '',
    timeSlots: [],
    duration: 0,
  })
  const [reservationWithName, setReservationWithName] = useState(true)
  const [visibleMenu, setVisibleMenu] = useState({
    visibleMenuOne: true,
    visibleMenuTwo: false,
  })
  
  // Stav pro aktivní sloty (pole)
  const [activeSlot, setActiveSlot] = useState([]);

  useEffect(() => {
    if (user) {
      setReservationData((prev) => ({ ...prev, user }));
    }
  }, [user]);

  useEffect(() => {
    if (quest) {
      setReservationData((prev) => ({...prev, quest}))
    }
  }, [quest])

  useEffect(() => {
    const fetchPublicData = async () => {
      try {
        
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/public/${businessId}`);
        setPublicData(response.data);
  
      } catch (err) {
        setMessage(err.response?.data.message || err.message);
      }
    };
    fetchPublicData();
  }, [businessId]);

  // Rezervační systém Sloty
  const handleDateChange = (date) => {
    setSelectedDate(date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    setFormatedSelectedDate(formattedDate);
    setReservationData((prevData) => ({
      ...prevData,
      date: formattedDate,
    }));
    if (business && businessToken) {
      if (reservationWithName) {
      setReservationDataWithName((prev) => ({
        ...prev,
        date: formattedDate,
      }))
      }
      setBusinessReservationData((prev) => ({
        ...prev,
        date: formattedDate,
      }))
    }
  };
  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
  
    setFormatedSelectedDate(formattedDate);
    setReservationData((prevData) => ({
      ...prevData,
      date: formattedDate,
    }));
  }, []);

  useEffect(() => {
    if (business && businessToken) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
  
    setFormatedSelectedDate(formattedDate);
    setBusinessReservationData((prevData) => ({
      ...prevData,
      date: formattedDate,
    }));
    setReservationDataWithName((prev) => ({
      ...prev,
      date: formattedDate,
    }))
    }
  }, [business, businessToken])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (business && businessToken) {
      if (reservationWithName) {
        const selectedService = publicData.services.find(service => service._id === value);
        setReservationDataWithName((prevData) => ({
          ...prevData,
          [name]: value,
          duration: selectedService ? selectedService.duration : 0,
        }));
        }
      setBusinessReservationData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (name === 'service') {
      const selectedService = publicData.services.find(service => service._id === value);
      setReservationData((prevData) => ({
        ...prevData,
        [name]: value,
        duration: selectedService ? selectedService.duration : 0,
      }));
    } else {
      setReservationData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
    
  };

  // Funkce pro výběr slotů podle trvání služby
  const selectedTimeSlots = (slot) => {
    const duration = reservationData.duration;
    const slotStartTime = slot.startTime;
    const selectedTimeSlots = [];
    let startTime = slotStartTime;
    let endTime = addMinutesToTime(startTime, 15);

    for (let i = 0; i < duration / 15; i++) {
      selectedTimeSlots.push(`${startTime} - ${endTime}`);
      startTime = endTime;
      endTime = addMinutesToTime(startTime, 15);
    }

    setReservationData((prevData) => ({
      ...prevData,
      timeSlots: selectedTimeSlots,
      available: false,
    }));


  // Pokud slot již není v activeSlot, přidej ho (ale jen jeden)
  setActiveSlot((prevActiveSlots) => {
  const isSlotActive = prevActiveSlots.some(activeSlot => activeSlot.startTime === slot.startTime);
  
  if (isSlotActive) {
    // Pokud je slot již aktivní, vrátíme předchozí stav
    return prevActiveSlots;
  } else {
    // Pokud slot není aktivní, přidej ho, ale zajisti, že bude jen jeden
    return [slot]; // V poli bude pouze tento nový slot
  }
});
  };

  // Funkce pro výběr slotů podle trvání služby
  const selectedTimeSlotsWithName = (slot) => {
    const duration = reservationDataWithName.duration;
    const slotStartTime = slot.startTime;
    const selectedTimeSlots = [];
    let startTime = slotStartTime;
    let endTime = addMinutesToTime(startTime, 15);

    for (let i = 0; i < duration / 15; i++) {
      selectedTimeSlots.push(`${startTime} - ${endTime}`);
      startTime = endTime;
      endTime = addMinutesToTime(startTime, 15);
    }

    setReservationDataWithName((prevData) => ({
      ...prevData,
      timeSlots: selectedTimeSlots,
      available: false,
    }));


  // Pokud slot již není v activeSlot, přidej ho (ale jen jeden)
  setActiveSlot((prevActiveSlots) => {
  const isSlotActive = prevActiveSlots.some(activeSlot => activeSlot.startTime === slot.startTime);
  
  if (isSlotActive) {
    // Pokud je slot již aktivní, vrátíme předchozí stav
    return prevActiveSlots;
  } else {
    // Pokud slot není aktivní, přidej ho, ale zajisti, že bude jen jeden
    return [slot]; // V poli bude pouze tento nový slot
  }
});
  };

  // Funkce pro výběr slotů podle business duration
  const selectedBusinessTimeSlots = (slot) => {
    const duration = businessReservationData.duration;
    const slotStartTime = slot.startTime;
    const selectedTimeSlots = [];
    let startTime = slotStartTime;
    let endTime = addMinutesToTime(startTime, 15);

    for (let i = 0; i < duration / 15; i++) {
      selectedTimeSlots.push(`${startTime} - ${endTime}`);
      startTime = endTime;
      endTime = addMinutesToTime(startTime, 15);
    }

    console.log(businessReservationData)
    setBusinessReservationData((prevData) => ({
      ...prevData,
      timeSlots: selectedTimeSlots,
      available: false,
    }));

    console.log(businessReservationData)
  // Pokud slot již není v activeSlot, přidej ho (ale jen jeden)
  setActiveSlot((prevActiveSlots) => {
  const isSlotActive = prevActiveSlots.some(activeSlot => activeSlot.startTime === slot.startTime);
  
  if (isSlotActive) {
    // Pokud je slot již aktivní, vrátíme předchozí stav
    return prevActiveSlots;
  } else {
    // Pokud slot není aktivní, přidej ho, ale zajisti, že bude jen jeden
    return [slot]; // V poli bude pouze tento nový slot
  }
});
  };


  const reservationFormSubmit = async (e) => {
    e.preventDefault();

    if (reservationData.user ) {
      if (!reservationData.timeSlots || reservationData.timeSlots.length === 0) {
        window.alert("Není zadán čas rezervace");
        return;
      }
    try {
      console.log(reservationData)
      setSending(true)
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/reservation/create`,
        reservationData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      setMessage(response?.data?.message);
    } catch (err) {
      setMessage(err.response?.data?.message || err.message);
    } finally {
      setSending(false)
      setTimeout(() => {
        window.location.reload()
      },1500)
    }
  } else if (business && businessToken) {
    if (reservationWithName) {

      try {
        setSending(true)
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/reservation/business-create-with-name`,
          reservationDataWithName,
          {
            headers: {
              Authorization: `Bearer ${businessToken}`,
            }
          }
        )
        setMessage(response?.data?.message);
      } catch (err) {
        setMessage(err.response?.data?.message)
      } finally {
        setSending(false)
        setTimeout(() => {
        },1500)
      }
    } else {
      try {
        setSending(true)
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/reservation/business-create`,
          businessReservationData,
          {
            headers: {
              Authorization: `Bearer ${businessToken}`,
            },
          }
        );
  
        setMessage(response?.data?.message);
      } catch (err) {
        setMessage(err.response?.data?.message || err.message);
      } finally {
        setSending(false)
        fetchBusiness()
        setTimeout(() => {
          setMessage(null)
        },2000)
      }
    }
    
  } else if (reservationData.quest) {
    if (!reservationData.timeSlots || reservationData.timeSlots.length === 0) {
      window.alert("Není zadán čas rezervace");
      return;
    }
    try {
      setSending(true)
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/reservation/quest-create`,
        reservationData
      )

      setMessage(response?.data?.message)

    } catch (err) {
      setMessage(err.response?.data?.message)
    } finally {
      setSending(false)
      setTimeout(() => {
        window.location.reload()
      },1500)
    }
  }
  };

  const addMinutesToTime = (time, minutes) => {
    if (!time || typeof time !== "string") {
      console.error("Invalid time format:", time);
      return "";
    }
    const [hours, minutesPart] = time.split(":").map(Number);
    const date = new Date(0, 0, 0, hours, minutesPart);
    date.setMinutes(date.getMinutes() + minutes);
    return `${date.getHours()}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  useEffect(() => {
    const fetchAvailableSlots = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/reservation/availableslots`, {
          params: { businessId, date: selectedDate },
        });
        setSlots(response.data.availableDates);
      } catch (error) {
        setMessage(error.data?.message || "Slot je obsazený");
      }
    };

    if (selectedDate) {
      fetchAvailableSlots();
    }
  }, [selectedDate, businessId]);


  return (
    <div className='business-container'>
      <div>
      {business && businessToken && <div className='slot-choice-buttons'>
        <button
          name="zakaznik"
          onClick={() => {
            setReservationWithName(true)
            setVisibleMenu({
              visibleMenuOne: true,
              visibleMenuTwo: false
            })
          }}
          className={`slot-choice-button ${visibleMenu.visibleMenuOne ? "active" : ""}`}
        >Zákazník</button>
        <button
          name="nepritomnost"
          onClick={() => {
            setReservationWithName(false)
            setVisibleMenu({
              visibleMenuOne: false,
              visibleMenuTwo: true
            })
          }}
          className={`slot-choice-button ${visibleMenu.visibleMenuTwo ? "active" : ""}`}
        >Nepřítomnost</button>
        </div>}
        <form onSubmit={reservationFormSubmit} className='form-slot-reservation'>
      <div>
        {business && businessToken &&
        <>

        { reservationWithName ? (<div className='manual-reservation'>
          <div className='basic-container'>
          <h2 className='check-title'>Jméno: </h2>
          <input 
            name='name'
            id='user-name'
            className="hotel-input"
            value={reservationDataWithName?.name || ""}
            onChange={handleInputChange}
          />
          </div>
          <div className='basic-container'>
          <h2 className='check-title'>Vyberte službu: </h2>
          <select
            name="service"
            id="services-select"
            value={reservationData.service || reservationDataWithName.service ||''}
            onChange={handleInputChange}
            className="reservation-select basic-input"
            
          >
            <option value="" disabled>Možnosti</option>
            {publicData?.services?.map((service) => (
              <option key={service._id} value={service._id}>
                {service.name}
              </option>
            ))}
          </select>
          </div>
  
        </div>) : (
          <div className='manual-reservation'>
          <div className='basic-container'>
          <h2 className='check-title'>Vyberte čas nepřítomnosti: </h2>
          <select
            name="duration"
            id="duration-select"
            value={businessReservationData.duration || ''}
            onChange={handleInputChange}
            className="reservation-select basic-input"
            
          >
            <option value="" disabled>Možnosti</option>
              <option value="15">
                15 Minut
              </option>
              <option value="30">
                30 Minut
              </option>
              <option value="45">
                45 Minut
              </option>
              <option value="60">
                60 Minut
              </option>
              <option value="75">
                75 Minut
              </option>
              <option value="90">
                90 Minut
              </option>
              <option value="105">
                105 Minut
              </option>
              <option value="120">
                120 Minut
              </option>
              <option value="135">
                135 Minut
              </option>
              <option value="150">
                150 Minut
              </option>
              <option value="165">
                165 Minut
              </option>
              <option value="180">
                180 Minut
              </option>
          </select>
          </div>
          </div>
        )}
        </>
        }
        {user && <div className='basic-container'>
          <h2 className='check-title'>Vyberte službu: </h2>
          <select
            name="service"
            id="services-select"
            value={reservationData.service || ''}
            onChange={handleInputChange}
            className="reservation-select basic-input"
            
          >
            <option value="" disabled>Možnosti</option>
            {publicData?.services?.map((service) => (
              <option key={service._id} value={service._id}>
                {service.name}
              </option>
            ))}
          </select>
          </div>}
          {quest && <div className='basic-container'>
          <h2 className='check-title'>Vyberte službu: </h2>
          <select
            name="service"
            id="services-select"
            value={reservationData.service || ''}
            onChange={handleInputChange}
            className="reservation-select basic-input"
            
          >
            <option value="" disabled>Možnosti</option>
            {publicData?.services?.map((service) => (
              <option key={service._id} value={service._id}>
                {service.name}
              </option>
            ))}
          </select>
          </div>}
      </div>
            
          <Calendar onChange={handleDateChange} />
        {!business && <>{reservationData.service ? (<div> {slots.filter((day) => day.date === formatedSelectedDate)
            .map((slot, index) => (
              <div key={index}>
                <div className="time-slot-container">
                  {slot.workHours.map((timeSlot, timeIndex) => (
                    <div
                      key={timeIndex}
                      className={`time-slot ${timeSlot.available ? "available" : "notAvailable"} 
                      ${activeSlot.some(active => active.startTime === timeSlot.startTime) ? "active" : ""}`} // Přidání třídy active pro všechny vybrané sloty
                      onClick={() => {
                        if (business && businessToken) {
                          selectedBusinessTimeSlots(timeSlot);
                        } else {
                          selectedTimeSlots(timeSlot);
                        }
                      }}
                      >
                      <span>{timeSlot.startTime}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            </div>) : <p className='slot-warning'>Pro zobrazení volných termínu vyberte službu</p>} 
            </> }

           {business && businessToken && <>
           { reservationWithName ? (<>
            {reservationDataWithName.duration ? (<div> {slots.filter((day) => day.date === formatedSelectedDate)
            .map((slot, index) => (
              <div key={index}>
                <div className="time-slot-container">
                  {slot.workHours.map((timeSlot, timeIndex) => (
                    <div
                      key={timeIndex}
                      className={`time-slot ${timeSlot.available ? "available" : "notAvailable"} 
                      ${activeSlot.some(active => active.startTime === timeSlot.startTime) ? "active" : ""}`} // Přidání třídy active pro všechny vybrané sloty
                      onClick={() => {
                        if (business && businessToken) {
                          if (reservationWithName) {
                            selectedTimeSlotsWithName(timeSlot)
                          }
                          selectedBusinessTimeSlots(timeSlot);
                        } else {
                          selectedTimeSlots(timeSlot);
                        }
                      }}
                      >
                      <span>{timeSlot.startTime}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            </div>) : <p className='slot-warning'>Pro zobrazení volných termínu vyberte časový úsek nepřítomnosti</p>
            } 
           </>) : (<>
           {businessReservationData.duration ? (<div> {slots.filter((day) => day.date === formatedSelectedDate)
            .map((slot, index) => (
              <div key={index}>
                <div className="time-slot-container">
                  {slot.workHours.map((timeSlot, timeIndex) => (
                    <div
                      key={timeIndex}
                      className={`time-slot ${timeSlot.available ? "available" : "notAvailable"} 
                      ${activeSlot.some(active => active.startTime === timeSlot.startTime) ? "active" : ""}`} // Přidání třídy active pro všechny vybrané sloty
                      onClick={() => {
                        if (business && businessToken) {
                          if (reservationWithName) {
                            selectedTimeSlotsWithName(timeSlot)
                          }
                          selectedBusinessTimeSlots(timeSlot);
                        } else {
                          selectedTimeSlots(timeSlot);
                        }
                      }}
                      >
                      <span>{timeSlot.startTime}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            </div>) : <p className='slot-warning'>Pro zobrazení volných termínu vyberte časový úsek nepřítomnosti</p>
            } 
           </>)}

            </>}
          <div className='slot-conteiner'>
            {selectedDate && ( <div>
              <div className="slot-price">
                <h2 className="check-title">Vybraný datum: </h2><p>{selectedDate.toLocaleDateString()}</p>
              </div>
            </div>
            )}
            {reservationData.service && (
            <div>
              <div className="slot-price">
                <h2 className="check-title">Trvání služby: </h2><p>{reservationData.duration} minut</p>
              </div>
            </div>
            )}
            {!reservationData.service && businessReservationData.duration && (
            <div>
              <div className="slot-price">
                <h2 className="check-title">Trvání nepřítomnosti: </h2><p>{reservationData.duration} minut</p>
              </div>
            </div>
            )}
            {activeSlot && <div>
              {activeSlot.map((item, index) => {
                return <div className='slot-price' key={index}>
                    <h2 className='check-title'>Kdy: </h2><p>{item.startTime}</p>
                  </div>
              })}
              </div>
            }
          </div>
          
          <button type="submit" className="hotel-submit-button">{sending ? "Vytvářím..." : "Potvrdit"}</button>
        </form>
      </div>
      {message && <p className='message'>{message}</p>}
    </div>
  );
};

export default BusinessPublicProfile;